import { useState, useEffect, useCallback } from "react";
import { loginWithEmail, logoutUser, onAuthStateChange, getUserData } from "../services/authService";

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChange(async (firebaseUser) => {
      setLoading(true);
      try {
        if (firebaseUser) {
          const userData = await getUserData(firebaseUser.uid);
          if (!userData) { await logoutUser(); setError("Tài khoản chưa được cấp quyền."); setUser(null); }
          else { setUser(userData); setError(null); }
        } else { setUser(null); setError(null); }
      } catch (err) { setError(err.message); setUser(null); }
      finally { setLoading(false); }
    });
    return () => unsubscribe();
  }, []);

  const login = useCallback(async (input, password, rememberMe = true) => {
    setLoading(true); setError(null);
    try {
      const userData = await loginWithEmail(input, password, rememberMe);
      setUser(userData);
      return userData;
    } catch (err) { setError(err.message); throw err; }
    finally { setLoading(false); }
  }, []);

  const logout = useCallback(async () => { await logoutUser(); setUser(null); }, []);
  const hasRole = useCallback((role) => user?.vaiTro?.includes(role), [user]);
  
  return { user, loading, error, login, logout, hasRole };
};